import { render } from "./Pickup.vue?vue&type=template&id=f718ec5a&scoped=true"
import script from "./Pickup.vue?vue&type=script&lang=js"
export * from "./Pickup.vue?vue&type=script&lang=js"

import "./Pickup.vue?vue&type=style&index=0&id=f718ec5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f718ec5a"]])

export default __exports__